import environment from '../environments/environment';

const userService = 'user';
const loanService = 'loan';
const lenderService = 'lender';
const loanpropertyService = 'poc/loanproperty';
const loanPublisherService = 'poc/loanpublisher';
const identityProviderAdminService = 'poc/userservice';
const identityProviderAuth = 'poc/userservice';
const backoffice = 'user/poclender';
const profile = 'profile';

// const propertyService = 'property'
// const basicAuth = 'auth';
// const oAuth = 'oauth2';
// const noAuth = 'guest';

const version = {
	1: 'v1',
	2: 'v2',
};

const endpoints = {
	mock: {
		LOGIN: `${environment.mock}/api/v1/login`,
		PORTOFOLIO_LIST: `${environment.mock}/apis/v1/lender/portofolio`,
		PORTOFOLIO_DETAIL: `${environment.mock}/apis/v1/lender/portofolio/detail`,
		LENDER_HEADER_SUMMARY: `${environment.mock}/apis/v1/lender/header`,
		USER_PORTOFOLIO_LIST: `${environment.mock}/apis/v1/lender/user-portfolio`,
		USER_PORTOFOLIO_DETAIL: `${environment.mock}/apis/v1/lender/user-portfolio-detail`,
		SET_CHANGE_PASSWORD: `${environment.mock}/apis/v2/user/change-password`,
		TRANSACTION_HISTORY_LIST: `${environment.mock}/apis/v1/user/transaction/list`,
		GENERATE_OTP: `${environment.mock}/api/v2/user/generate-otp`,
		MATCH_OTP: `${environment.mock}/api/v2/user/match-otp`,
		FORGOT_PASSWORD: `${environment.mock}/api/v2/user/forgot-password`,
		MARKETPLACE_LIST: `${environment.mock}/loan/auth/apis/v1/lender/marketplace/list`,
	},
	api: {
		LOGIN: `${environment.api}/poc/${userService}/guest/${version[2]}/login`,
		PORTOFOLIO_LIST: `${environment.api}/poc/${loanService}/poclender/${version[1]}/lender/portofolio`,
		PORTOFOLIO_DETAIL: `${environment.api}/poc/${loanService}/poclender/${version[1]}/lender/portofolio/detail`,
		LENDER_HEADER_SUMMARY: `${environment.api}/poc/${loanService}/poclender/${version[1]}/lender/header`,
		USER_PORTOFOLIO_LIST: `${environment.api}/poc/${loanService}/poclender/${version[1]}/lender/user-portofolio`,
		USER_PORTOFOLIO_DETAIL: `${environment.api}/poc/${loanService}/poclender/${version[1]}/lender/user-portofolio-detail`,
		SET_CHANGE_PASSWORD: `${environment.api}/poc/${backoffice}/${version[2]}/change-password`,
		TRANSACTION_HISTORY_LIST: `${environment.api}/poc/${userService}/pocbackoffice/${version[1]}/${userService}/transaction/list`,
		TRANSACTION_HISTORY_CSV: `${environment.api}/${loanPublisherService}/poclender/${version[1]}/${lenderService}/bulk-funding/transaction-report`,
		GENERATE_OTP: `${environment.api}/poc/${userService}/guest/${version[2]}/generate-otp`,
		MATCH_OTP: `${environment.api}/poc/${userService}/guest/${version[2]}/match-otp`,
		FORGOT_PASSWORD: `${environment.api}/poc/${userService}/guest/${version[2]}/forgot-password`,
		MARKETPLACE_LIST: `${environment.api}/poc/${loanService}/poclender/${version[1]}/lender/marketplace/list`,
		DOWNLOAD_DOCUMENT: `${environment.api}/${identityProviderAdminService}/poclender/${version[1]}/document/download`,
		FUNDING: `${environment.api}/${loanPublisherService}/poclender/${version[1]}/${lenderService}/loan/fund`,
		WITHDRAW: `${environment.api}/${identityProviderAuth}/poclender/${version[1]}/${userService}/bank/withdraw`,
		AGREEMENT: `${environment.api}/${loanPublisherService}/poclender/${version[1]}/${lenderService}/generate-loan-agreement`,
		COORPORATE_USER_PROFILE: `${environment.api}/poc/${backoffice}/${version[1]}/${profile}/lender-institution`,
		WITHDRAW_FEE: `${environment.api}/poc/${loanService}/pocbackoffice/${version[1]}/payment/transfer-fee`,
		TNC_LIST: `${environment.api}/${loanpropertyService}/apis/${version[1]}/master/tncpp`,
		LOAN_TYPE: `${environment.api}/${loanPublisherService}/pocbackoffice/${version[1]}/admin/loan-product/list`,
		TKB: `${environment.api}/${loanpropertyService}/guest/v1/compro-data`,
		BULK_MARKET_LIST: `${environment.api}/poc/loan/poclender/v1/lender/marketplace/bulk-list`,
		BULK_SUMMARY_LIST: `${environment.api}/poc/loan/poclender/v1/partner-loan/bulk-fund-detail`,
		SUBMIT_BULK_FUNDING: `${environment.api}/${loanPublisherService}/poclender/v1/bulk-funding`,
		BULK_LOAN_NUMBER: `${environment.api}/poc/loan/poclender/v1/partner-loan/bulk-fund-detail/summary`,
		CHECK_PASSWORD: `${environment.api}/poc/userservice/poclender/v1/validate-mpas`,
		WIDGET_PROGRESS: `${environment.api}/poc/loan/poclender/v1/lender/portofolio/bulk-funding-widget`,
	},
};

export default endpoints;
